import { createSelector } from 'reselect';
import { RootState } from 'store';
import { getPurchaseCartTotal } from 'types/Purchase';

export const getPurchaseCart = (state: RootState) => state.purchases.cart;

export const getPurchaseCartTotalAmount = createSelector([getPurchaseCart], getPurchaseCartTotal);

export const getPurchaseCartHasItems = createSelector([getPurchaseCart], cart =>
    Object.values(cart).some(offerIds => offerIds.length > 0)
);
